import { StructureDto, StructureObjectDto } from '@/endpoints/models'

type BatchEditErrors = Record<string | number, string>
export interface BatchEditContextState {
	errors: BatchEditErrors,
	formChanged: Record<string, unknown>,
	locking: boolean,
	/** Right-clicked node in tree panel */
	node: StructureDto,
	onClose: () => void,
	selectedNodes: number[],
	selectedStructures: StructureDto[],
	/** Skip lock validation (set after force unlock) */
	skipLockCheck?: boolean,
	submitting: boolean,
	type: StructureObjectDto.TypeEnum
}

export interface BatchEditContextType {
	dispatch: React.Dispatch<Actions>,
	state: BatchEditContextState
}

export enum ActionTypeEnum {
	SET,
	FORM_CHANGED_UPDATE,
}

type ActionSet = {
	state: Partial<BatchEditContextState>,
	type: ActionTypeEnum.SET
}

type ActionFormChangedUpdate = {
	formChanged: Record<string, unknown>,
	type: ActionTypeEnum.FORM_CHANGED_UPDATE
}

export type Actions = ActionSet | ActionFormChangedUpdate
